module.exports = __webpack_public_path__ + "static/media/bike.49836934.svg";